import { Component, OnInit,ViewChild } from '@angular/core';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError, ActivatedRoute } from '@angular/router';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { GisService } from 'src/app/services/gis/gis.service';
import { BreadcrumbComponent } from 'src/app/common/breadcrumb/breadcrumb.component';
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { isNullOrUndefined } from 'util';
import { TranslateService } from '@ngx-translate/core';
import { url } from 'inspector';

@Component({
  selector: 'app-infobox',
  templateUrl: './infobox.component.html',
  styleUrls: ['./infobox.component.css']
})
export class InfoboxComponent implements OnInit {
  @ViewChild(CdkVirtualScrollViewport, {})
  public viewPort: CdkVirtualScrollViewport;
  activeSpinner : Boolean;
  myObserver;
  hidestatereports : boolean;
  tabledata = {};
  shownonhimtable : boolean;
  showhimtable : boolean;
  showunter : boolean;
  himalayanList = [];
  northEasternList = [];
  unionTertData = {};
  tablenonhimdata = {};
  clickdist :boolean = false;
  shownonhimalayantable :boolean;
  indicatorTableData = [];
  unionTeritoriesList = [];
  indicatorsdata;
  urlParams : object;
  yearlist : [];
  year;
  
  @ViewChild(BreadcrumbComponent) breadCrumb: BreadcrumbComponent;
  separateData: any;
  arrayelements = [];
  tableObject = [];
  selecteddist: any;
  shownortheastern: boolean = false
  showut: boolean = false;
  mapclick: boolean
  districtsdata: {};
  infodistricts: any[];
  mapclickregion = {};
  datafortables: any;
  tablemapObject: any;
  regionwise: any;
  tabledataforBihar = [];
  tabledataforJK =[];
  showBhTable: boolean;
  showJKtable :boolean;
  tabledataforUP: any =[];
  tabledataforUK: any[];
  tabledataforWB: any[];
  editreportTableData: any;
  editTableData: any[];
  tabledataindicators: any =[];
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public utils: UtilsModule,
    private translate: TranslateService,
    private constants : ConstantsModule,
    private gisService : GisService,
    private submitdataservice : SubmitdataService
  ) { 
    translate.setDefaultLang('en');
    this.myObserver = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // Show loading indicator
      }

      if (event instanceof NavigationEnd) {
        this.initializeOnStateLoad();
      }

      if (event instanceof NavigationError) {
        // Hide loading indicator
        // Present error to user
      }
    });
  }
  ngOnDestroy() {
    this.myObserver.unsubscribe();
  }
  ngOnInit() {
    // this.getlocationrankingData();
  }
  initializeOnStateLoad(){
    let urlComponent = this.route.snapshot.paramMap.get('component');
    // this.breadCrumb.update(this.router.url);
    this.urlParams = this.utils.getWritableObject(this.route.snapshot.params);
    
    // }
    this.hidestatereports = (this.urlParams['loctype'] == "COUNTRY") ? true : false;
    this.yearlist = this.gisService.getassesmentYear();
    this.year = this.urlParams['assesmentyear'] ? this.urlParams['assesmentyear'] : this.yearlist[this.yearlist.length-1];
    this.getlocationrankingData();

  //   if(this.hidestatereports){
  //     this.getlocationrankingData();
  //   } else{
  //     this.getIndicatorRankingData();
  // }
}
changeRegion(value){
  if(this.urlParams['loctype'] == "STATE" && this.urlParams['mapOnClickParams']){
    if(value[1]['label'] == 'NON HIMALAYAN'){
      this.clickdist = true;
      this.shownonhimalayantable = true;
      this.shownortheastern = false;
      this.showut = false;
    } else if(value[1]['label'] == 'NORTH EASTERN AND HIMALAYAN'){
      this.clickdist = true;
      this.shownortheastern = true;
      this.shownonhimalayantable = false;
      this.showut = false;
    } else if(value[1]['label'] == "UNION TERRITORIES"){
      this.clickdist = true;
      this.showut = true;
      this.shownortheastern = false;
      this.shownonhimalayantable = false;
    }
      }

}
  getLocationRanking(){
    this.activeSpinner = true;
    this.tabledata = {};
    this.tablenonhimdata = {};
    this.unionTertData = {};
    // this.himalayanList = [];
    this.northEasternList = [];
    this.unionTeritoriesList = [];
    let postdata = {};
    this.shownonhimtable = false;
    this.showhimtable = false;
    this.showunter = false;
    postdata = this.getbasicparams();
    postdata['cList'] = this.urlParams['district'] ? this.urlParams['district'].split(',') : ['ALL'];
    // console.log('postdataaaa------------------>',postdata);
    if(this.urlParams['loctype'] == "COUNTRY"){
      this.clickdist = false;

      this.gisService.getLocationRanking(postdata).subscribe(data =>{
         this.tabledata = data['NON HIMALAYAN'];
         this.tablenonhimdata = data['NORTH EASTERN AND HIMALAYAN'];
         this.unionTertData = data['UNION TERRITORIES']
         if(!isNullOrUndefined(this.tabledata)){
          Object.keys(this.tabledata).forEach(key => {
          Object.keys(this.tabledata[key]).forEach(element => {
            if(!this.himalayanList.includes(this.tabledata[key])){
              this.himalayanList.push(this.tabledata[key][element]);

            }
            
          });
          
        });
      } else if(!isNullOrUndefined(this.tablenonhimdata)){
        Object.keys(this.tablenonhimdata).forEach(key => {
          Object.keys(this.tablenonhimdata[key]).forEach(element => {
            if(!this.northEasternList.includes(this.tabledata[key])){
            this.northEasternList.push(this.tablenonhimdata[key][element])
            }
          });
          
        });
      } else if(!isNullOrUndefined(this.unionTertData)){
        Object.keys(this.unionTertData).forEach(key => {
          Object.keys(this.unionTertData[key]).forEach(element => {
            if(!this.unionTeritoriesList.includes(this.tabledata[key])){
            this.unionTeritoriesList.push(this.unionTertData[key][element])
            }
          });
          
        });
      }
      });
      this.activeSpinner = false;
  } else{
    this.clickdist = true;
    this.getTableDistricts();
  }
}
getTableDistricts(){
  this.districtsdata = {};
  this.infodistricts = [];
  let postdata = this.getbasicparams();
  postdata['cList'] = this.urlParams['state'] ? this.urlParams['state'].split(',') : ['ALL'];
  // console.log('postdata---------1111-------------',postdata);
  this.gisService.getLocationRanking(postdata).subscribe(data =>{
    this.districtsdata = data;
    Object.keys(this.districtsdata).forEach(key => {
      Object.keys(this.districtsdata[key]).forEach(element => {
        Object.keys(this.districtsdata[key][element]).forEach(district => {
          this.infodistricts.push(this.districtsdata[key][element][district]);
        })
      })
      
    });
  });
  this.activeSpinner = false;

}
  getIndicatorRanking(){
    let postdata = {};
    postdata = this.getbasicparams();
    postdata['lu'] = this.urlParams['stateuuid'];
    postdata['reportType'] = true;
    postdata['isPreviousYearDataReq'] = true;
    this.gisService.getIndicatorRanking(postdata).subscribe(data =>{
      this.indicatorsdata = data;
      this.getIndicatorsHeirarchy();
    });
  }
  getIndicatorsHeirarchy(){
    this.activeSpinner = true;
    let postdata = {};
    this.indicatorTableData = [];
    postdata['ay'] = this.urlParams['assesmentyear'];
    this.submitdataservice.getIndicatorsHeirarchy(postdata).subscribe(data =>{
      if(data.length > 0)
         this.preparedataforhtml(data); 
      else 
          this.indicatorTableData = [];
      this.activeSpinner = false;
    });
  }
  preparedataforhtml(data){
    let index = 0;
    data.forEach(element => {
      let i = 0;
      element['childList'].forEach(list => {
          this.indicatorsdata.forEach(obj => {
            if(obj['uuid'] == list['entityUUID'] && list['label'] == obj['name']){
              list['rank'] = obj['rank'];
              list['score'] = obj['score'];
              i++
              index++;
              list['index'] = index;
              if(i == 1){
                this.indicatorTableData.push(element);
              }
              this.indicatorTableData.push(list);
            }
          });
        // }
      });
    });
  }
  getlocationrankingData(){
    this.activeSpinner = true;
    this.showBhTable = false;
    this.showJKtable = false;
    this.tabledataforBihar = [];
    this.tabledataforJK = [];
    this.tabledataforUP = [];
    this.tabledataforUK = [];
    this.tabledataforWB = []
    let postdata ={
      "ay" : this.urlParams['assesmentyear'] || "2020-2021",
      "view" : this.constants.VIEWS['admin'],
      "cList" : this.urlParams['district'] ? this.urlParams['district'].split(',') : ['ALL'],
      "cType" : this.constants.LOCATION_CONSTANT['DISTRICT'],
      "pType" : this.constants.LOCATION_CONSTANT['STATE'],
      "subTp" : this.urlParams['month'],
      "pID":null,
    }
    // console.log('urlparams',this.urlParams);
    // console.log('postdata22222222222222222222',postdata);
    this.gisService.getLocationRanking(postdata).subscribe(data =>{
      this.tabledata = data;
      if(this.tabledata['BIHAR'].length > 0){
        this.showBhTable = true;
        Object.keys(this.tabledata['BIHAR']).forEach(key =>{
         Object.keys(this.tabledata['BIHAR'][key]).forEach(district =>{
           this.tabledataforBihar.push(this.tabledata['BIHAR'][key][district]);
          //  console.log("nxbscnds",this.tabledataforBihar)
         })
        })
      } else{
        this.tabledataforBihar = [];
      }
      if(this.tabledata['JHARKHAND'].length > 0){
        this.showJKtable = true;
        Object.keys(this.tabledata['JHARKHAND']).forEach(key =>{
          Object.keys(this.tabledata['JHARKHAND'][key]).forEach(district =>{
            this.tabledataforJK.push(this.tabledata['JHARKHAND'][key][district]);
          })
         })
      } else{
        this.tabledataforJK = [];
      }
      if(this.tabledata['UTTAR PRADESH'].length > 0){
        Object.keys(this.tabledata['UTTAR PRADESH']).forEach(key =>{
          Object.keys(this.tabledata['UTTAR PRADESH'][key]).forEach(district =>{
            this.tabledataforUP.push(this.tabledata['UTTAR PRADESH'][key][district]);
          })
         })
      } else{
        this.tabledataforUP = [];
      }
      if(this.tabledata['UTTARAKHAND'].length > 0){
        Object.keys(this.tabledata['UTTARAKHAND']).forEach(key =>{
          Object.keys(this.tabledata['UTTARAKHAND'][key]).forEach(district =>{
            this.tabledataforUK.push(this.tabledata['UTTARAKHAND'][key][district]);
          })
         })
      } else{
        this.tabledataforUK = [];
      }
      if(this.tabledata['WEST BENGAL'].length > 0){
        Object.keys(this.tabledata['WEST BENGAL']).forEach(key =>{
          Object.keys(this.tabledata['WEST BENGAL'][key]).forEach(district =>{
            this.tabledataforWB.push(this.tabledata['WEST BENGAL'][key][district]);
          })
         })
      } else{
        this.tabledataforWB = [];
      }


    });
    this.activeSpinner = false;
  }
  getIndicatorRankingData() {
    this.activeSpinner = true;
    this.tabledataindicators = [];
    let postdata = {
      "view": "admin",
      "cType": this.constants.LOCATION_CONSTANT['DISTRICT'],
      "pType": this.constants.LOCATION_CONSTANT['BASIN'],
      "ay": this.urlParams['assesmentyear'] || "2020-2021",
      "lu": this.urlParams['locuuid'],
      "reportType": true,
      "subTp": this.urlParams['month'],
      "isPreviousYearDataReq": true
    }
    this.gisService.getIndicatorRanking(postdata).subscribe(data => {
      this.activeSpinner = false;
      this.editreportTableData = data;
      this.editreportTableData.forEach(report =>{
        this.tabledataindicators.push(report)
      })
    })
  }
  checkscorevalue(val){
    return val == 0 ? 0 : (val !=0 && val ? (val).toFixed(2) : '')
  }
  getbasicparams(){
    let postdata ={};
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['cType'] = this.urlParams['loctype'] == 'COUNTRY' ? this.constants.LOCATION_CONSTANT['STATE'] : this.constants.LOCATION_CONSTANT['DISTRICT'],
    postdata['pType'] = this.urlParams['loctype'] == 'COUNTRY' ? this.constants.LOCATION_CONSTANT['REGION']  : this.constants.LOCATION_CONSTANT['STATE'],
    postdata['pID'] = this.urlParams['loctype'] == 'COUNTRY' ? this.constants.REGIONKEY :  this.urlParams['stateuuid']
    postdata['ay'] = this.urlParams['assesmentyear'] || "2019-2020"
    // console.log('post data',postdata);
    return postdata;
  }
  onClick(row){
    if (row) {
      this.urlParams = this.utils.getWritableObject(this.route.snapshot.params);
      this.urlParams['locname'] = row['name'];
      this.selecteddist = row['name'];
      this.urlParams['locuuid'] = row['uuid'];
      if(this.urlParams['loctype'] == 'COUNTRY'){
        this.urlParams['stateuuid'] = this.urlParams['locuuid'];
      }
     
      this.urlParams['loctype'] = this.constants.GETLOTIONHIRUTOL[this.urlParams['loctype']]
      let parentLocation = this.urlParams['parentLocName'];
      delete this.urlParams["parentLocName"];
      delete this.urlParams["bounds"];
      delete this.urlParams["z"];
      this.router.navigate(["/gis",parentLocation,this.urlParams]);
    }
  }
  validatefixedValue(value){
    if(!isNullOrUndefined(value)){
  return Number(value.toFixed(2)).toLocaleString('en-IN');
    }else{
      return '-';
    }
    
  } 

}
